import { LOAD_ROLES } from "flows/roles_per_service/action_types"

export const load = () => ({
    type: LOAD_ROLES,
})
